export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20digital%20landscape%20with%20flowing%20data%20streams%20and%20geometric%20shapes%2C%20dark%20background%20with%20warm%20crimson%20red%20and%20amber%20highlight%20accents%2C%20mysterious%20atmosphere%2C%20representing%20encrypted%20information%20flow%2C%20cinematic%20composition%2C%20no%20text%20no%20letters%20no%20human%20faces%2C%20artistic%20abstract%20style%20with%20glowing%20particles&width=1800&height=1000&seq=hero-bg-darkweb&orientation=landscape"
          alt="51暗网吃瓜"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-accent-300 whitespace-nowrap">每日更新 · 高清流畅 · 一手掌握</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight">
              51暗网吃瓜
              <span className="block text-accent-400 text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-2">
                全网热门吃瓜视频聚集地
              </span>
            </h1>

            <p className="text-sm md:text-base text-accent-300/80 font-medium mt-3 mb-6">
              实时追踪 · 一手掌握 · 永不掉线
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0">
              51暗网吃瓜汇集全网最新、最热的吃瓜视频资源，覆盖51吃瓜在线、51cg吃瓜等热门频道。
              每日持续更新暗网吃瓜直播与精选视频，为您提供流畅高清的在线观看体验。
              无论您关注的是娱乐圈热点、社会事件追踪还是网络热议话题，这里都有您想要的吃瓜内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-lg bg-primary-500/30 flex items-center justify-center">
                  <i className="ri-vidicon-line text-primary-300 text-sm"></i>
                </span>
                <div className="text-left">
                  <p className="text-lg font-bold text-background-50">10,000+</p>
                  <p className="text-xs text-background-50/50">精选视频</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-lg bg-accent-500/30 flex items-center justify-center">
                  <i className="ri-fire-line text-accent-300 text-sm"></i>
                </span>
                <div className="text-left">
                  <p className="text-lg font-bold text-background-50">24h</p>
                  <p className="text-xs text-background-50/50">持续追踪</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-lg bg-primary-500/30 flex items-center justify-center">
                  <i className="ri-shield-check-line text-primary-300 text-sm"></i>
                </span>
                <div className="text-left">
                  <p className="text-lg font-bold text-background-50">匿名安全</p>
                  <p className="text-xs text-background-50/50">隐私保护</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                立即吃瓜
              </a>
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium text-sm rounded-full border border-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line"></i>
                浏览视频
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden border border-background-50/10 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Mysterious%20smartphone%20floating%20in%20digital%20space%20with%20glowing%20red%20and%20amber%20data%20streams%20flowing%20around%20it%2C%20dark%20background%20with%20particle%20effects%2C%20representing%20secret%20information%20access%2C%20futuristic%20cyber%20style%2C%20dramatic%20lighting%2C%20no%20text%20no%20human%20faces%2C%20high%20contrast&width=800&height=600&seq=hero-visual-phone&orientation=portrait"
                alt="51暗网吃瓜在线观看"
                className="w-full h-auto object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 md:p-6">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center shrink-0">
                    <i className="ri-play-fill text-background-50 text-lg"></i>
                  </span>
                  <div className="min-w-0">
                    <p className="text-background-50 text-sm font-medium truncate">最新吃瓜视频 · 正在热播</p>
                    <p className="text-background-50/50 text-xs">51cg吃瓜 · 实时更新</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}